export default __webpack_public_path__ + "static/gray-moneyback-c427e41e50998d8bc2874980961c7277.png";